import classNames from "classnames";
import React, { FunctionComponent, ReactElement } from "react";
import { ReactComponent as IconRemove } from "../../../../../icons/trash-filled.svg";
import "./style.scss";

interface Props {
  children: ReactElement;
  onSelectItem: (selected: boolean) => void;
  selected?: boolean;
}

const RemovablePage: FunctionComponent<Props> = ({ children, onSelectItem, selected }) => {
  const onItemSelectedHandler = () => {
    onSelectItem(!selected);
  };

  return (
    <div
      className={classNames("RemovablePage", {
        "RemovablePage--selected": selected,
      })}
      onClick={onItemSelectedHandler}
    >
      {children}
      <div className="RemovablePage-icon-selected">
        <IconRemove />
      </div>
    </div>
  );
};

export default RemovablePage;
